'use client';

import { c as _c } from "react/compiler-runtime";
import { LandingPageSplitContext } from '@/app/l/_lib/landingPagePageTypes';
import { useEffect, useState } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
import { LandingPageFirebaseType } from '@poppy/firebase';
interface ContentAnalyticsProps {
  contentDetails: Pick<LandingPageFirebaseType, 'nodeId' | 'pageSlug' | 'title' | 'clientFeatures' | 'pageType'>;
  isEditMode: boolean;
  ownerUserId: string;
  currentUserId: string | null;
  isGuestUser?: boolean;
  pageType?: 'landingPage' | 'presentation';
  splitContext?: LandingPageSplitContext;
}
const ContentAnalytics = t0 => {
  const $ = _c(11);
  const {
    contentDetails,
    isEditMode,
    ownerUserId,
    currentUserId,
    isGuestUser: t1,
    pageType: t2,
    splitContext
  } = t0;
  const isGuestUser = t1 === undefined ? false : t1;
  const pageType = t2 === undefined ? "landingPage" : t2;
  const {
    track
  } = useAnalytics();
  const [hasTrackedView, setHasTrackedView] = useState(false);
  let t3;
  let t4;
  if ($[0] !== contentDetails || $[1] !== currentUserId || $[2] !== hasTrackedView || $[3] !== isEditMode || $[4] !== isGuestUser || $[5] !== ownerUserId || $[6] !== pageType || $[7] !== splitContext || $[8] !== track) {
    t3 = () => {
      if (hasTrackedView) {
        return;
      }
      const isInIframe = window !== window.top;
      if (isInIframe || isEditMode) {
        return;
      }
      const sessionKey = splitContext?.splitId ? `landing_page_view_${contentDetails.pageSlug}_${splitContext.splitId}` : `landing_page_view_${contentDetails.pageSlug}`;
      const hasViewedInSession = sessionStorage.getItem(sessionKey);
      if (hasViewedInSession) {
        return;
      }
      const isOwnerViewing = currentUserId && ownerUserId && currentUserId === ownerUserId;
      fetch("/api/landing-page/track-view", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          landingPageId: contentDetails.pageSlug,
          nodeId: contentDetails.nodeId,
          splitId: splitContext?.splitId,
          variantNodeId: splitContext?.variantNodeId
        })
      }).catch(_temp);
      track("Landing Page Views", {
        nodeId: contentDetails.nodeId,
        landingPageSlug: contentDetails.pageSlug,
        landingPageTitle: contentDetails.title,
        hasCountdown: !!contentDetails.clientFeatures?.countdown,
        isOwnerView: !!isOwnerViewing,
        isGuestUser,
        userType: isGuestUser ? "guest" : "authenticated",
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        pageType: contentDetails.pageType || "landingPage",
        via: splitContext ? "ab" : "direct",
        splitId: splitContext?.splitId,
        variantNodeId: splitContext?.variantNodeId
      });
      sessionStorage.setItem(sessionKey, "true");
      setHasTrackedView(true);
      console.log(`📊 ${pageType} view tracked: ${contentDetails.pageSlug} (${isGuestUser ? "guest" : "authenticated"} user)`);
    };
    t4 = [track, contentDetails, isEditMode, ownerUserId, currentUserId, isGuestUser, hasTrackedView, pageType, splitContext];
    $[0] = contentDetails;
    $[1] = currentUserId;
    $[2] = hasTrackedView;
    $[3] = isEditMode;
    $[4] = isGuestUser;
    $[5] = ownerUserId;
    $[6] = pageType;
    $[7] = splitContext;
    $[8] = track;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  return null;
};
export default ContentAnalytics;
function _temp(error) {
  console.error("Failed to persist landing page view:", error);
}